/**
 * @generated SignedSource<<66436dd0ab537848d4cbb2a0bdbf6985>>
 * @relayHash f6a30ee6ee1e3e60e7ac3366d295bd46
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5da9c5aa8b3c6f6d93f01d05e399d0b1abce793bce7cc920b4ad912ceecc37af

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type priorityIssueTransitionIssueAdjustmentsQuery$variables = {
  ari: string;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
};
export type priorityIssueTransitionIssueAdjustmentsQuery$data = {
  readonly node: {
    readonly id?: string;
    readonly priorities?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly iconUrl: AGG$URL | null | undefined;
          readonly label: string | null | undefined;
          readonly priorityId: string;
          readonly value: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type priorityIssueTransitionIssueAdjustmentsQuery = {
  response: priorityIssueTransitionIssueAdjustmentsQuery$data;
  variables: priorityIssueTransitionIssueAdjustmentsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ari"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "filterById"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "ari"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = [
  {
    "kind": "Variable",
    "name": "filterById",
    "variableName": "filterById"
  },
  {
    "kind": "Literal",
    "name": "searchBy",
    "value": ""
  }
],
v4 = {
  "alias": "value",
  "kind": "ScalarField",
  "name": "id"
},
v5 = {
  "alias": "label",
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "priorityId"
},
v7 = {
  "kind": "ScalarField",
  "name": "iconUrl"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "priorityIssueTransitionIssueAdjustmentsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraPriorityConnection",
                "kind": "LinkedField",
                "name": "priorities",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraPriorityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraPriorityField"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "priorityIssueTransitionIssueAdjustmentsQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v3/*: any*/),
                "concreteType": "JiraPriorityConnection",
                "kind": "LinkedField",
                "name": "priorities",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraPriorityEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraPriority",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v2/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              }
            ],
            "type": "JiraPriorityField"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "5da9c5aa8b3c6f6d93f01d05e399d0b1abce793bce7cc920b4ad912ceecc37af",
    "metadata": {},
    "name": "priorityIssueTransitionIssueAdjustmentsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "5e7c742934e2b174f578c445449fb8d9";

export default node;
